(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

window.addEventListener('scroll', function () {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        document.getElementById("nav").className = "fixed navigation";
    } else {
        document.getElementById("nav").className = "navigation";
    }
});

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.slider__track')) {

        var intViewportWidth = window.innerWidth;
        var prev = document.querySelector('.btn__slider--prev');
        var next = document.querySelector('.btn__slider--next');

        var track = document.querySelector('.slider__track');

        var sliderWidth = document.querySelector('.slider__container').offsetWidth;

        window.addEventListener('resize', function () {
            sliderWidth = document.querySelector('.slider__container').offsetWidth;
        });

        var index = 0;

        if (intViewportWidth > 1220) {

            next.addEventListener('click', function () {
                index++;
                prev.classList.add('show');
                track.style.transform = "translateX(-" + index * sliderWidth / 4 + "px)";

                if (track.offsetWidth - index * sliderWidth / 4 < sliderWidth) {
                    next.classList.add('hide');
                }
            });

            prev.addEventListener('click', function () {
                index--;
                next.classList.remove('hide');
                if (index === 0) {
                    prev.classList.remove('show');
                }
                track.style.transform = "translateX(-" + index * sliderWidth / 4 + "px)";
            });
        } else if (intViewportWidth <= 1220) {

            next.addEventListener('click', function () {
                index++;
                prev.classList.add('show');
                track.style.transform = "translateX(-" + index * sliderWidth / 3 + "px)";

                if (track.offsetWidth - index * sliderWidth / 3 < sliderWidth) {
                    next.classList.add('hide');
                }
            });

            prev.addEventListener('click', function () {
                index--;
                next.classList.remove('hide');
                if (index === 0) {
                    prev.classList.remove('show');
                }
                track.style.transform = "translateX(-" + index * sliderWidth / 3 + "px)";
            });
        }

        if (intViewportWidth > 675 && intViewportWidth <= 900) {

            next.addEventListener('click', function () {
                index++;
                prev.classList.add('show');
                track.style.transform = "translateX(-" + index * sliderWidth / 4 + "px)";

                if (track.offsetWidth - index * sliderWidth / 4 < sliderWidth) {
                    next.classList.add('hide');
                }
            });

            prev.addEventListener('click', function () {
                index--;
                next.classList.remove('hide');
                if (index === 0) {
                    prev.classList.remove('show');
                }
                track.style.transform = "translateX(-" + index * sliderWidth / 4 + "px)";
            });
        } else if (intViewportWidth <= 675) {

            next.addEventListener('click', function () {
                index++;
                prev.classList.add('show');
                track.style.transform = "translateX(-" + index * sliderWidth / 2 + "px)";

                if (track.offsetWidth - index * sliderWidth / 2 < sliderWidth) {
                    next.classList.add('hide');
                }
            });

            prev.addEventListener('click', function () {
                index--;
                next.classList.remove('hide');
                if (index === 0) {
                    prev.classList.remove('show');
                }
                track.style.transform = "translateX(-" + index * sliderWidth / 2 + "px)";
            });
        }
    }

    if (document.querySelector('.reseller-faq__box--label')) {

        var accordions = document.querySelectorAll(".reseller-faq__box--label");

        accordions.forEach(function (accordion) {
            accordion.addEventListener('click', function () {
                // accordion.classList.toggle('active');
                var accordionBody = accordion.nextElementSibling;
                if (accordion.classList.contains('active')) {
                    accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';
                } else {
                    accordionBody.style.maxHeight = 0;
                }
            });
        });
    }

    if (document.querySelector('[data-tab-target]')) {

        var tabs = document.querySelectorAll('[data-tab-target]');
        var tabContents = document.querySelectorAll('[data-tab-content]');

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var target = document.querySelector(tab.dataset.tabTarget);
                tabContents.forEach(function (tabContent) {
                    tabContent.classList.remove('active');
                });
                tabs.forEach(function (tab) {
                    tab.classList.remove('active');
                });
                tab.classList.add('active');
                target.classList.add('active');
            });
        });
    }

    if (document.querySelector('.form-control')) {
        var showError = function showError(input, message) {
            var formControl = input.parentElement;
            formControl.className = 'become-form__box__form--inner--input form-control error';
            var small = formControl.querySelector('small');
            small.innerText = message;
        };

        var showSuccess = function showSuccess(input) {
            var formControl = input.parentElement;
            formControl.className = 'become-form__box__form--inner--input form-control success';
        };

        //Check phone 

        var checkNumber = function checkNumber(input) {
            var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            if (input.value.match(phoneno)) {
                showSuccess(input);
            } else {
                showError(input, 'Please check if your phone number is valid');
            }
        };

        //Check email

        var checkEmail = function checkEmail(input) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (re.test(input.value.trim())) {
                showSuccess(input);
            } else {
                showError(input, 'Email is not valid');
            }
        };

        //Check required function

        var checkRequired = function checkRequired(inputArr) {
            inputArr.forEach(function (input) {
                if (input.value.trim() === '') {
                    showError(input, 'This field is required');
                } else {
                    showSuccess(input);
                }
            });
        };

        //Check input length 

        var checkLength = function checkLength(input, min, max) {
            if (input.value.length < min) {
                showError(input, "Must be at least " + min + " characters");
            } else if (input.value.length > max) {
                showError(input, "Must be less than " + max + " characters");
            } else {
                showSuccess(input);
            }
        };

        var form = document.getElementById('form');
        var fname = document.getElementById('fname');
        var lname = document.getElementById('lname');
        var email = document.getElementById('email');
        var phone = document.getElementById('phone');
        var company = document.getElementById('company');

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            checkRequired([fname, lname, email, phone, company]);
            checkLength(fname, 2, 20);
            checkLength(lname, 2, 20);
            checkLength(company, 2, 30);
            checkEmail(email);
            checkNumber(phone);
        });
    }
});

//Hamburger Menu 
document.addEventListener('DOMContentLoaded', function () {
    var hamburger = document.getElementById('hamburger');
    var navUL = document.querySelector('.navigation__list');
    var submenu = document.querySelector('.navigation__list').getElementsByTagName('li');
    var numSubmenu = submenu.length;
    var menuOpen = false;

    function myToggle() {
        this.classList.toggle('visible-menu');
    }

    for (var i = 0; i < numSubmenu; i++) {
        submenu[i].addEventListener('click', myToggle, false);
    }

    hamburger.addEventListener('click', function () {
        // navUL.classList.toggle('show-nav')

        if (!menuOpen) {
            hamburger.classList.add('open');
            menuOpen = true;
        } else {
            hamburger.classList.remove('open');
            menuOpen = false;
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {

    var imageCameras = document.querySelectorAll(".trucks-cams__trucks--image .icon");
    var truckBox = document.querySelectorAll(".trucks-cams__cams__box");

    imageCameras.forEach(function (item, index) {
        item.addEventListener('mouseover', function (item) {
            var elmId = item.target.getAttribute("data-href");
            document.getElementById(elmId).classList.add('hover');
        });
        item.addEventListener('mouseout', function (item) {
            var elmId = item.target.getAttribute("data-href");
            document.getElementById(elmId).classList.remove('hover');
        });
    });

    truckBox.forEach(function (item, index) {
        item.addEventListener('mouseover', function (item) {
            var elmId = item.target.getAttribute("data-target");
            document.getElementById(elmId).classList.add('hover');
        });
        item.addEventListener('mouseout', function (item) {
            var elmId = item.target.getAttribute("data-target");
            document.getElementById(elmId).classList.remove('hover');
        });
    });

    truckBox.forEach(function (item, index) {
        item.addEventListener('mouseover', function (item) {
            var elmId = item.target.getAttribute("data-href");
            document.getElementById(elmId).classList.add('hover');
        });
        item.addEventListener('mouseout', function (item) {
            var elmId = item.target.getAttribute("data-href");
            document.getElementById(elmId).classList.remove('hover');
        });
    });
});

window.addEventListener("scroll", function () {
    document.body.scrollTop > 50 || document.documentElement.scrollTop > 50 ? document.getElementById("nav").className = "fixed navigation" : document.getElementById("nav").className = "navigation";
}), document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".slider__track")) {
        var intViewportWidth = window.innerWidth;var prev = document.querySelector(".btn__slider--prev"),
            next = document.querySelector(".btn__slider--next"),
            track = document.querySelector(".slider__track");var sliderWidth = document.querySelector(".slider__container").offsetWidth;window.addEventListener("resize", function () {
            sliderWidth = document.querySelector(".slider__container").offsetWidth;
        });var index = 0;intViewportWidth > 1220 ? (next.addEventListener("click", function () {
            index++, prev.classList.add("show"), track.style.transform = "translateX(-" + index * sliderWidth / 4 + "px)", track.offsetWidth - index * sliderWidth / 4 < sliderWidth && next.classList.add("hide");
        }), prev.addEventListener("click", function () {
            index--, next.classList.remove("hide"), 0 === index && prev.classList.remove("show"), track.style.transform = "translateX(-" + index * sliderWidth / 4 + "px)";
        })) : intViewportWidth <= 1220 && (next.addEventListener("click", function () {
            index++, prev.classList.add("show"), track.style.transform = "translateX(-" + index * sliderWidth / 3 + "px)", track.offsetWidth - index * sliderWidth / 3 < sliderWidth && next.classList.add("hide");
        }), prev.addEventListener("click", function () {
            index--, next.classList.remove("hide"), 0 === index && prev.classList.remove("show"), track.style.transform = "translateX(-" + index * sliderWidth / 3 + "px)";
        })), intViewportWidth > 675 && intViewportWidth <= 900 ? (next.addEventListener("click", function () {
            index++, prev.classList.add("show"), track.style.transform = "translateX(-" + index * sliderWidth / 4 + "px)", track.offsetWidth - index * sliderWidth / 4 < sliderWidth && next.classList.add("hide");
        }), prev.addEventListener("click", function () {
            index--, next.classList.remove("hide"), 0 === index && prev.classList.remove("show"), track.style.transform = "translateX(-" + index * sliderWidth / 4 + "px)";
        })) : intViewportWidth <= 675 && (next.addEventListener("click", function () {
            index++, prev.classList.add("show"), track.style.transform = "translateX(-" + index * sliderWidth / 2 + "px)", track.offsetWidth - index * sliderWidth / 2 < sliderWidth && next.classList.add("hide");
        }), prev.addEventListener("click", function () {
            index--, next.classList.remove("hide"), 0 === index && prev.classList.remove("show"), track.style.transform = "translateX(-" + index * sliderWidth / 2 + "px)";
        }));
    }if (document.querySelector(".reseller-faq__box--label")) {
        var accordions = document.querySelectorAll(".reseller-faq__box--label");accordions.forEach(function (accordion) {
            accordion.addEventListener("click", function (event) {
                accordion.classList.toggle("active");var accordionBody = accordion.nextElementSibling;accordion.classList.contains("active") ? accordionBody.style.maxHeight = accordionBody.scrollHeight + "px" : accordionBody.style.maxHeight = 0;
            });
        });
    }if (document.querySelector("[data-tab-target]")) {
        var tabs = document.querySelectorAll("[data-tab-target]"),
            tabContents = document.querySelectorAll("[data-tab-content]");tabs.forEach(function (tab) {
            tab.addEventListener("click", function () {
                var target = document.querySelector(tab.dataset.tabTarget);tabContents.forEach(function (tabContent) {
                    tabContent.classList.remove("active");
                }), tabs.forEach(function (tab) {
                    tab.classList.remove("active");
                }), tab.classList.add("active"), target.classList.add("active");
            });
        });
    }if (document.querySelector(".form-control")) {
        var showError = function showError(input, message) {
            var formControl = input.parentElement;formControl.className = "become-form__box__form--inner--input form-control error";var small = formControl.querySelector("small");small.innerText = message;
        };

        var showSuccess = function showSuccess(input) {
            var formControl = input.parentElement;formControl.className = "become-form__box__form--inner--input form-control success";
        };

        var checkNumber = function checkNumber(input) {
            var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;input.value.match(phoneno) ? showSuccess(input) : showError(input, "Please check if your phone number is valid");
        };

        var checkEmail = function checkEmail(input) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;re.test(input.value.trim()) ? showSuccess(input) : showError(input, "Email is not valid");
        };

        var checkRequired = function checkRequired(inputArr) {
            inputArr.forEach(function (input) {
                "" === input.value.trim() ? showError(input, "This field is required") : showSuccess(input);
            });
        };

        var checkLength = function checkLength(input, min, max) {
            input.value.length < min ? showError(input, "Must be at least " + min + " characters") : input.value.length > max ? showError(input, "Must be less than " + max + " characters") : showSuccess(input);
        };

        var form = document.getElementById("form"),
            fname = document.getElementById("fname"),
            lname = document.getElementById("lname"),
            email = document.getElementById("email"),
            phone = document.getElementById("phone"),
            company = document.getElementById("company");form.addEventListener("submit", function (e) {
            e.preventDefault(), checkRequired([fname, lname, email, phone, company]), checkLength(fname, 2, 20), checkLength(lname, 2, 20), checkLength(company, 2, 30), checkEmail(email), checkNumber(phone);
        });
    }
}), document.addEventListener("DOMContentLoaded", function () {
    var hamburger = document.getElementById("hamburger"),
        navUL = document.querySelector(".navigation__list");var menuOpen = !1;hamburger.addEventListener("click", function () {
        navUL.classList.toggle("show-nav"), menuOpen ? (hamburger.classList.remove("open"), menuOpen = !1) : (hamburger.classList.add("open"), menuOpen = !0);
    });
}), document.addEventListener("DOMContentLoaded", function () {
    var imageCameras = document.querySelectorAll(".trucks-cams__trucks--image .icon");imageCameras.forEach(function (item, index) {
        console.log(item), item.addEventListener("mouseover", function (item) {
            var elmId = item.target.getAttribute("data-href");document.getElementById(elmId).classList.add("hover");
        }), item.addEventListener("mouseout", function (item) {
            var elmId = item.target.getAttribute("data-href");document.getElementById(elmId).classList.remove("hover");
        });
    });
});

},{}]},{},[1]);
